import { Flex, useColorModeValue, Center, Text } from '@chakra-ui/react';

const KeyStatItem = (props) => {
  const {
    icon,
    text,
    children,
    percentageChange,
    displayPercentageChange = true,
    tileBg,
  } = props;
  const modeBoxBg = useColorModeValue('white', '#243744');

  return (
    <Center
      bg={tileBg || modeBoxBg}
      borderRadius="15px"
      px={8}
      py={2}
      height="100%"
    >
      <Flex flexDir="column" w="100%">
        <Text fontSize="18px" fontFamily="Inter Regular" fontWeight="100">
          {text}
        </Text>
        <Flex
          flexDir="row"
          justify="space-between"
          align="center"
          w="100%"
          mt={-1}
          gap={3}
        >
          <Text textStyle="heading3">{children}</Text>
          {displayPercentageChange && (
            <Flex flexDir="column" align="flex-end">
              {icon}
              <Text fontSize="12px" color="#989898" mt={-1}>
                {percentageChange} vs last month
              </Text>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Center>
  );
};

export default KeyStatItem;
